import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const MonthIndex = lazy(() => import('./:month/:tab/Index'))

export const CrewWageRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path='/:month/:tab/*' element={<MonthIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
